export const ITEM_MENU_OPTIONS = {
  SELECT_ALL: 'SELECT_ALL',
  DESELECT_ALL: 'DESELECT_ALL',
  DOWNLOAD: 'DOWNLOAD',
  MOVE: 'MOVE',
  DELETE: 'DELETE',
  OPEN_IN_LIBRARY: 'OPEN_IN_LIBRARY',
};
